export default {
  lcp: {
    account_info: 'Account Info',
    active: 'Active',
    add_email: 'Add email',
    add_existing_user_question:
      'Would you like to add this existing user to {organization}, or do you want to create a new user with a different username?',
    add_existing_user_to_org: 'Add existing user to {organization}',
    add_group: 'Add group',
    assign_group_for_all_users: 'Assign a group for all users',
    add_group_code: 'Add group code',
    add_members: 'Add members',
    add_qr_code: 'Add QR Code',
    add_user: 'Add another user',
    admin: 'Administrator',
    already_exists: 'Already exists',
    app_settings: 'App specific settings',
    applying_password: 'Applying password to {count} users',
    at_least_min_length_characters: 'At least {min_length} characters required',
    at_most_max_length_characters: 'At most {max_length} characters allowed',
    authorization_error: 'Authorization Error',
    back: 'Back',
    bankid: 'Bank ID',
    bankid_invalid: 'Bank ID is invalid.',
    cancel: 'Cancel',
    choose_language: 'Choose Language',
    class: 'Class',
    close: 'Close',
    close_side_panel: 'Close side panel',
    code: 'Code',
    confirm_delete: 'Confirm delete',
    confirm_group_deletion: 'Confirm group deletion',
    confirm_group_deletion_final_accounts_message:
      'Student accounts in this group will be permanently deleted from all our services.',
    confirm_group_deletion_final_data_message: 'All data saved by these students will be lost.',
    confirm_group_deletion_final_undone_message: 'This action cannot be undone.',
    confirm_group_deletion_message: 'Are you sure you want to delete this group? This action cannot be undone.',
    confirm_group_deletion_no_delete_students_message:
      'User accounts that are part of the selected group will not be deleted.',
    confirm_group_deletion_yes_delete_students_message:
      'All student accounts that are part of the selected group will also be deleted. This action cannot be undone and all data associated with the students will be permanently removed.',
    confirm_multiple_groups_deletion: 'Deletion of groups',
    confirm_multiple_groups_deletion_final_accounts_message:
      'Student accounts in the selected groups will be permanently deleted from all our services.',
    confirm_multiple_groups_deletion_message:
      'Are you sure you want to delete these {count} groups? This action cannot be undone.',
    confirm_multiple_groups_deletion_no_delete_students_message:
      'User accounts that are part of the selected groups will not be deleted.',
    confirm_multiple_groups_deletion_yes_delete_students_message:
      'All student accounts that are part of the selected groups will also be deleted. This action cannot be undone and all data associated with the students will be permanently removed.',
    confirm_multiple_users_deletion: 'Deletion of users',
    confirm_multiple_users_deletion_message:
      'Are you sure you want to delete these {count} users? This action cannot be undone and all data associated with the selected users will be permanently removed.',
    confirm_password_required: 'Confirm Password is required',
    confirm_qr_code_removal: 'Confirm QR code removal',
    confirm_qr_code_removal_message:
      "Do you want to remove this QR code? Once removed, it will no longer work. To get a new one, you'll need to create a login card.",
    confirm_user_deletion: 'Confirm user deletion',
    confirm_user_deletion_message:
      'Are you sure you want to delete this user? This action cannot be undone and all data associated with this user will be permanently removed.',
    confirmation_create_users_card_button: 'Create more users',
    confirmation_create_users_card_info:
      'Usernames and passwords have been generated for the user and can be found in the downloaded file.',
    confirmation_create_users_card_subtitle: 'Account created successfully',
    confirmation_login_card_button: 'Download Login Cards',
    confirmation_login_card_info:
      'Download and share this login card to help the user sign in for the first time. If the user has a provided email, they will receive a login link.',
    confirmation_login_card_info_only_employees:
      "Login cards are only made for students. Since you only created teachers or administrators, there aren't any cards to print right now. If you add students later, you'll be able to download their cards here.",
    confirmation_login_card_subtitle: 'Login details',
    confirmation_support_card_button: 'To support',
    confirmation_support_card_info:
      'You can edit user details anytime from the users profile. If you need assistance, visit our Support for guides and contact options.',
    confirmation_support_card_subtitle: 'Get started',
    conflict_error: 'Conflict found',
    conflict_is_resolved: 'Conflict is resolved',
    conflict_progress: '{progress} of {total} conflicts',
    conflicts_resolved_info: 'You can close this window to proceed with creating users.',
    conflicts_resolved_title: 'All conflicts resolved!',
    copied: 'Copied!',
    copy: 'Copy',
    correct_form_errors: 'Please correct the errors in the form.',
    create_and_download: 'Create and download',
    create_another_group: 'Create another group',
    create_group_with_members_count: 'Create group ({members_count} members)',
    create_login_card_warning:
      'Creating a login card will generate new login credentials and make the selected ones invalid. Make sure to notify the user.',
    create_multiple_new_users: 'Create multiple new users',
    create_new: 'Create New',
    create_new_group: 'Create new group',
    create_new_login_card: 'Create new login card',
    create_new_login_cards: 'Create new login cards',
    create_user: 'Create user',
    create_user_description: 'Create one user or multiple users – choose an option below.',
    create_user_username_info:
      "The username will be set to the user's email address. If no email is provided, a unique username will be generated.",
    create_users: 'Create users',
    create_users_with_count: 'Create {count} users',
    created: 'Created',
    expiry_date: 'Expiry date',
    not_set: 'Not set',
    expiry_date_info: 'When this date is reached, the group will be deleted.',
    creating_login_cards_for_users: 'Creating login cards for {count} users',
    data_table_loading_please_wait: 'Loading... Please wait.',
    data_table_no_data: 'No data available',
    delete: 'Delete',
    delete_group: 'Delete group',
    delete_groups: 'Delete groups',
    delete_students_in_group: 'Delete students in this group',
    delete_students_in_groups: 'Delete students in these groups',
    delete_user: 'Delete user',
    delete_users: 'Delete users',
    disabled: 'Disabled',
    done: 'Done',
    download_login_card: 'Download login card',
    download_login_cards: 'Download login cards',
    duplicate: 'Duplicate',
    duplicate_title: 'Duplicate names detected',
    duplicate_users_warning:
      "You're about to create multiple users with the same name. If needed, remove any duplicates before proceeding.",
    edit: 'Edit',
    edit_group: 'Edit group',
    edit_user: 'Edit user',
    email: 'Email',
    email_invalid: 'The email address is invalid.',
    email_example: "jane.doe{'@'}example.com",
    email_not_set: 'Not email set',
    email_required: 'Email *',
    employee: 'Employee',
    enabled: 'Enabled',
    eppn: 'Eppn',
    error_deleting_groups: 'Error deleting groups',
    error_deleting_users: 'Error deleting users',
    error_occurred: 'An error occurred.',
    errors: {
      conflict_error: 'Property already exist',
      error_occurred: 'An error occurred. Please try again',
      username_already_taken: 'Username already taken',
    },
    failed_to_add_user_to_organization: 'Failed to add user to organization',
    failed_to_create_group: 'Failed to create group',
    failed_to_create_login_card: 'Failed to create login card.',
    failed_to_create_user: 'Failed to create user',
    failed_to_create_users: 'Failed to create {count} users',
    failed_to_delete_group: 'Failed to delete group.',
    failed_to_delete_user: 'Failed to delete user',
    failed_to_update_password: 'Failed to update password for {count} users',
    failed_to_update_user: 'Failed to update user',
    failed_to_update_user_association: 'Failed to update user association',
    filter_by_group: 'Filter by group',
    filters: 'Filters',
    'filters-apply': 'Apply',
    'filters-clear': 'Clear filters',
    filter_no_filter: 'No filter',
    filter_only_users_with_mfa: 'Only users with MFA',
    filter_only_users_without_mfa: 'Only users without MFA',
    'filters-reset': 'Reset filters',
    first_name: 'First Name',
    fix_errors_before_processing: 'Fix errors before processing',
    fix_errors_before_submitting: 'Fix errors before submitting',
    forbidden_error: 'Permission denied',
    form_could_not_be_found: 'Form could not be found',
    fullname: 'Name',
    generate_login_cards: 'Generate Login Cards',
    generate_new: 'Generate new',
    google_email: 'Google Email',
    go_to_group: 'Go to group',
    go_to_user_profile: 'Go to user profile',
    grade: 'Grade',
    group_code: 'Group code',
    group_code_generated_successfully: 'Group code generated successfully',
    group_code_info: 'Members of the group can use the group code to log in.',
    group_code_removed_successfully: 'Group code removed successfully',
    group_created_instructions:
      'Visit the group page to add more users, add a group code, edit the name or remove members',
    group_created_successfully: 'Group created successfully',
    group_created_successfully_count_members: 'Group created successfully with {count} members',
    group_deleted_successfully: 'Group successfully deleted.',
    group_has_no_members: 'Group has no members',
    group_in_school: 'Group in {school}',
    group_info: 'Group Info',
    group: 'Group',
    group_login: 'Group login',
    group_members_updated_reload_Later:
      'Group members updated successfully. You may need to reload the page see the changes.',
    group_members_updated_successfully: 'Group members updated successfully.',
    group_members_updating: 'Updating group members',
    group_name: 'Group name',
    group_name_taken: 'Group name is already taken',
    group_required: 'Group required',
    group_type: 'Group type',
    group_type_class: 'Class',
    group_type_null: '-',
    group_type_subject: 'Subject',
    group_updated_failed: 'Failed to update group',
    group_updated_successfully: 'Group updated successfully.',
    group_updated_successfully_count_members_failed:
      'Group created successfully with {count} members, but failed to add {failedCount} members',
    group_users_will_be_deleted_count: '{count} users in the group will be deleted',
    group_users_will_not_be_deleted_count: '{count} users in the group will not be deleted',
    groups: 'Groups',
    groups_deleted_count: '{count} groups deleted',
    groups_selected_count: '{count} groups selected',
    gsuiteemail: 'Google Email',
    guardian: 'Guardian',
    hide_password: 'Hide password',
    hide_repeat_password: 'Hide repeat password',
    ignore_errors_continue: 'Ignore {count} errors and continue',
    internal_control_panel: 'Internal Control Panel',
    ilt_home: 'ILT Home',
    import_users: {
      change_rows_and_import: 'Change these and import the file again',
      choose_file: 'Choose file',
      clear: 'CLEAR',
      creating_groups: 'Creating groups',
      delete_employees: "Should teachers that don't exist in the file be removed from the organization?",
      delete_guardians: "Should guardians that don't exist in the file be removed from the organization?",
      delete_students: 'Should students who are not on the list be deleted from the organization?',
      duplicate_identifier: 'This value is used on more than one row in the file',
      duplicate_username: 'This username is used on more than one row in the file',
      email: 'Email address (not required for students)',
      employee: 'Employee',
      excel_template_for_upload: 'Excel template for upload',
      fetching_existing_users: 'Fetching existing users',
      fetching_groups: 'Fetching groups',
      file_is_empty: 'The file you tried to import was empty',
      file_type_is_invalid: "The uploaded file must end with '.xlsx'",
      groups_created: 'Groups are created',
      guardian: 'Guardian ',
      guide_in_english_language: 'in English',
      guide_in_native_language: 'in English',
      guides_about_the_tool: 'Guide that describes how to use the tool can be found here',
      import_forbidden: 'You do not have permission to edit this user',
      import_via_the_tool: 'Import via excel',
      imported_users_of: 'Imported {finished} users of {total}',
      importing_users: 'Importing users',
      name: 'Name (First and / or Last name)',
      no_excell_import_right: 'Excel import is not enabled',
      disallowed_role_rows_warning:
        'The file contains {count} {roles} rows. Such accounts cannot be created in {organizationType} organizations — only users who already have that role can keep it.',
      removing_users: 'Delete users',
      required_missing: 'Missing ',
      rows_have_errors: 'Rows contained errors',
      rows_uploaded: 'rows are uploaded',
      start_import: 'Start import',
      student: 'Student',
      the_tool_description:
        'Here you can add, move or delete multiple accounts at once by uploading an excel file. Start by downloading the template below that is adapted for uploading. Note that this is exactly the template you can use. If you adjust the columns, there is a risk that the upload will not work. Instead, leave fields that are not used empty.',
      title: 'Import users',
      type: 'Type (Employee/student/guardian)',
      upload_summery: '(user) rows are uploaded',
      username: 'Username',
      users_not_imported: 'These users were not imported',
    },
    import_users_button: 'Import users',
    in_progress: 'In progress. Please don’t close this page.',
    inactive: 'Inactive',
    invalid_input: 'Invalid parameter',
    last_active: 'Last active',
    last_name: 'Last Name',
    last_update: 'Last update',
    learn_more_about_group_logins: 'Learn more about group logins here.',
    leave_without_saving: 'Leave without saving',
    let_me_choose_username_password: 'Let me choose the username and password',
    login_as_user: 'Login as user',
    login_card_created_successfully: 'Login card created successfully.',
    login_card_ready:
      'Your login card is ready. It will start downloading automatically. If it doesn’t, click the button below to download it manually.',
    login_cards_created_successfully: 'Login card created successfully.',
    logout: 'Logout',
    manage_group_members_for: 'Manage Group Members for {groupName}',
    manage_group_members_for_short: 'Manage Members - {groupName}',
    manage_groups: 'Manage Groups',
    manage_login: 'Manage Login',
    manage_members: 'Manage Members',
    manage_members_with_count: 'Manage Members ({count})',
    manage_user_groups_for: 'Manage groups for {username}',
    manage_user_organizations: 'Manage organizations',
    manage_user_organizations_for: 'Manage organizations for {username}',
    max_length: 'Maximum {max} characters allowed.',
    member_removed_successfully: 'Member has been removed from group.',
    members: 'Members',
    membership_removed_error: 'Failed to remove membership',
    membership_removed_successfully: 'Membership removed successfully',
    mfa_enabled: 'MFA Enabled',
    microsoft_365: 'Microsoft 365',
    min_length: 'Minimum {min} character required.',
    multiple_users: 'Multiple users',
    must_match_password: 'Must match password',
    my_profile: 'My Profile',
    n_more_organizations: '{count} more organization | {count} more organizations',
    name: 'Name',
    new_group: 'New group',
    new_group_created: 'New group created',
    new_password: 'New password',
    new_user: 'New user',
    new_user_created: 'New user created!',
    new_users_created: '{count} new user(s) created!',
    no: 'No',
    no_changes_saved: 'No changes saved',
    no_groups_available: 'No groups available',
    no_groups_found: 'No groups found',
    no_students_to_delete_in_group: 'There are no student accounts in this group that can be deleted.',
    no_students_to_delete_in_groups: 'There are no student accounts in the selected groups that can be deleted.',
    no_organization_selected_warning:
      'No organization is selected. If the user has no other organizations, they will be deleted.',
    not_affected: 'Not affected ({count} teachers or guardians)',
    not_creating_login_cards_for_users: 'Not creating login cards for {count} users',
    office365id: 'Microsoft 365',
    organization_name: 'Organization name',
    organization_type: {
      demo: 'demo',
      municipality: 'municipality',
      preschool: 'preschool',
      school: 'school',
      workplace: 'workplace',
    },
    organization_not_found_alert: 'Organization you seek is not found. You are seeing another organization.',
    password: 'Password',
    password_min_length: 'Password must be at least 8 characters',
    password_required: 'Password is required',
    password_success_users_in_group: 'Password was successfully changed for {updated} out of {total} users.',
    password_update_error: 'Some users password could not be updated. Please try again.',
    password_update_failed: 'Password update failed',
    password_updated: 'Password updated',
    passwords_do_not_match: 'Passwords do not match',
    paste_users_names_here: 'Paste users names here, one per line.',
    permissions: {
      escalate_login_hint: 'Click to log in with MFA.',
      managed_by_sso: 'User is managed by SSO',
      managed_by_sync: 'User is managed by sync',
      mfa_required: 'You must login with MFA (BankId or SMS)',
      not_permitted: 'The action is not permitted.',
      only_admin_or_employee_permitted: 'Only administrator or teachers are permitted',
      only_admin_permitted: 'Only administrators are permitted',
      only_group_manager_permitted: 'Only group managers are permitted',
      only_super_user_permitted: 'Only super users are permitted',
      organization_inactive: 'The organization is inactive',
      property_readonly: 'Property is read-only',
      "property_required_for_employees'": 'Property is required for employees',
      property_unsupported_for_employees: 'Unsupported property',
      property_unsupported_for_non_employees: 'Unsupported property',
      qr_login_disabled: 'QR code login is disabled',
      subscription_required: 'Subscription required',
      user_inactive: 'The user is inactive',
      user_management_disabled: 'User management disabled',
    },
    qr_code_help: 'You can create and print a login card to help the user log in.',
    qrcode: 'QR code',
    remove: 'Remove',
    remove_group_code: 'Remove group code',
    remove_group_code_confirmation:
      'Do you want to remove this group code? Once removed, members in the group will not be able to use it for log in. Users individual passwords will not change.',
    remove_group_member: 'Remove group member',
    remove_group_member_confirmation:
      "Do you want to remove this group member? They will lose access to the group and its resources. Their account and password won't change.",
    remove_group_membership: 'Remove group membership',
    remove_group_membership_message:
      'Do you want to remove this group membership? User will lose access to the group and its resources.',
    remove_qr_code: 'Remove QR Code',
    repeat_password: 'Repeat password',
    required: 'This field is required.',
    required_email_for: 'Required valid email for {name} ({role})',
    required_email_info:
      "Teachers and guardians are required to have a valid email address. Enter this user's email below.",
    required_field: 'The field is required.',
    required_group_info: 'All users must belong to a group. Select a group for this user below.',
    required_name: 'Required valid name, requires at least 4 characters',
    required_name_info: "All users required a valid name(at least 4 characters long) . Enter this user's name below.",
    reset_list: 'Reset list',
    resolve_conflicts: 'Resolve {count} conflicts',
    retry_errors: 'Retry {count} users',
    retry_setting_password: 'Retry setting password',
    role: 'Role',
    role_admin: 'Admin',
    role_employee: 'Employee',
    role_guardian: 'Guardian',
    role_in: 'Role in {school}',
    role_in_school: '{role} in {school}',
    role_in_school_highlighted: '<b>{role}</b> in <b>{school}</b>',
    role_invalid: 'Role is invalid',
    role_student: 'Student',
    save: 'Save',
    save_count_members: 'Save ({count} members)',
    search: 'Search',
    search_across_organizations: 'Search Across Organizations',
    search_for_user: 'Search for user',
    search_in_across_organizations: 'Search Across Organizations',
    search_in_current_organization: 'Current Organization',
    search_options: 'Search options',
    search_users: 'Search users',
    secure_login: 'Secure Login',
    select: 'Select',
    select_action: 'Select action',
    select_all: 'Select all',
    select_all_x_users: 'Select all users {count}',
    select_at_least_one_option: 'Please select at least one option.',
    select_existing_user_or_create: 'Select an existing user or create new',
    select_login_credentials: 'Select login credentials to renew and display on the login card.',
    select_organization: 'Select Organization',
    select_role: 'Select role',
    selected: 'Selected',
    set_password: 'Set password',
    set_password_to_group: 'Set password to group',
    set_password_to_group_info:
      'Setting a new password will overwrite the current password for all student users in this group and apply the same chosen password to each of them.',
    set_password_warning:
      'This will overwrite the password for all { count } student users in this group. Be sure to notify them of this change. Teachers and guardians will not be affected.',
    shared_account: 'Shared Account',
    show_less: 'Show Less',
    show_more: 'Show More',
    show_password: 'Show password',
    show_repeat_password: 'Show repeat password',
    single_user: 'Single user',
    skolfederation: 'Skolfederation',
    skolon: 'Skolon',
    sms: 'SMS',
    sms_invalid: 'The phone number is invalid.',
    student: 'Student',
    subject: 'Subject',
    successfully_created_users: 'Successfully created {count} users',
    support: 'Support',
    text_identifier_example: 'Example',
    to_profile: 'To profile',
    treat_login_card_as_sensitive:
      'Treat each login card as sensitive information. Ensure users keep it secure and avoid sharing or losing it, as anyone with access can use it to log into the associated account.',
    type: 'Type',
    undo: 'Undo',
    unknown: 'Unknown',
    unknown_error: 'Unknown error',
    unsaved_changes: 'Unsaved changes',
    unsaved_changes_message: 'You have unsaved changes. Your changes will be lost if you leave.',
    upload_csv: 'Upload CSV',
    upload_multiple_users: 'Upload Multiple Users',
    upload_users: 'Upload users',
    use_different_username: 'Use a different username',
    user_added_to_organization: 'User added to organization',
    user_already_exists: '{name} already exists',
    user_already_exists_explain:
      'A user with the same name already exists. Would you like to use the already existing user or create a new one?',
    user_created_successfully: 'User created successfully',
    user_deleted_successfully: 'User deleted successfully',
    user_groups_save_failed: 'User groups saving failed',
    user_groups_save_some_failed:
      'User could not be removed from {removedCount} groups and/or added to {addedCount} groups',
    user_groups_successfully_saved: 'User groups successfully saved',
    user_organizations_save_failed: 'User organizations saving failed',
    user_organizations_successfully_saved: 'User organizations successfully saved',
    user_updated_successfully: 'User updated successfully',
    user_will_be_updated: 'User {name} will be updated. Password and QR code will be regenerated!',
    user_will_not_change_but_activated:
      "{role} {name} will be activated if not active. Password and QR code won't be updated!",
    user_with_username_found:
      'A user with username "{username}" was found in at least one organization you manage. Please review the details below.',
    username: 'Username',
    username_already_in_use: 'Username is already in use',
    username_taken: 'Username is already taken',
    username_taken_choose_a_different_username: 'Choose a different username',
    username_taken_in_unreachable_scope: 'Username is already taken out of your scope.',
    users: 'Users',
    users_deleted_count: '{count} users deleted',
    users_selected_count: '{count} users selected',
    validation_error: 'Validation failed',
    value_invalid: 'The value is invalid.',
    yes: 'Yes',
    what_you_can_do_in_the_user_profile: 'You can add login methods, add user to groups or edit details in the profile',
    autogenerated_if_left_empty: 'Autogenerated if left empty',
    create_a_new_user: 'Create a new user',
    optional: 'optional',
    age_limit: 'Age limit',
    age_range: '{min}-{max} years',
    no_age_limit: 'No age limit',
    age_limit_dialog_title: '{app} age limit',
    speaking_book_rights_learn_more: 'Learn more',
    speaking_book_rights_support_url:
      'https://support.ilteducation.se/kb/guide/sv/talbok-och-talboksrattigheter-a1bJR2gTz8/Steps/3427559',
    speaking_book_rights_dialog_title: '{app} speaking book rights',
    speaking_book_rights_dialog_description:
      'Speaking book rights grant access to adapted literature in accordance with accessibility regulations.',
    speaking_book_rights_dialog_learn_more: 'Learn more about it here.',
    speaking_book_rights_dialog_question: 'Enable speaking book rights for this user?',
    speaking_book_rights_yes: 'Yes',
    speaking_book_rights_no: 'No',
    speaking_book_rights_unavailable: 'Not available',
    speaking_book_rights_edit_secure_login: 'Sign in securely to see or edit',
    nothing_to_update: 'Nothing to update',
  },
  serviceNames: {
    'audio-aid': 'Audio Aid',
    polylino: 'Polylino',
  },
  content_settings: {
    label_content_settings: 'Content settings',
    label_edit_content_settings: 'Edit content settings',
    label_age_setting: 'Age setting',
    description_age_setting: 'Set the age limit for the content you want to see',
    label_another_setting: 'Another setting',
    label_edit_settings: 'Edit settings',
    label_not_available: 'Not available',
    label_setting_on_all_students: 'Settings will added to all this students',
    label_saved_successfully: 'Settings saved successfully',
    label_save_failed: 'Failed to save settings',
    label_deleted_successfully: 'Settings deleted successfully',
    label_delete_failed: 'Failed to delete settings',
    button_done: 'Done',
    button_delete: 'Delete',
    button_save: 'Save',
    button_cancel: 'Cancel',
    button_reset: 'Reset',
    message_age_filter: 'The age limit limits the available books for students in Polylino school',
    label_current_age_input_min: 'Minimum age',
    label_current_age_input_max: 'Maximum age',
    button_decrease_min_age: 'Decrease minimum age',
    button_increase_min_age: 'Increase minimum age',
    button_decrease_max_age: 'Decrease maximum age',
    button_increase_max_age: 'Increase maximum age',
  },
  components: {
    label_saved_speaking_book_rights_successfully: 'Speaking book rights saved successfully',
    label_save_speaking_book_rights_failed: 'Failed to save speaking book rights',
    label_speaking_book_rights: 'Speaking book rights',
  },
};
